import React from 'react';

const INDUSTRIES = [
  "E-Commerce",
  "MedSpa",
  "Legal and Law Firms",
  "Wealth Management",
  "Home Services or Renovation",
  "B2B SaaS",
];

export const IndustryBanner = () => {
  const items = [...INDUSTRIES, ...INDUSTRIES, ...INDUSTRIES];

  return (
    <section data-testid="industry-banner" className="bg-primary py-4 overflow-hidden">
      <div className="flex animate-marquee whitespace-nowrap">
        {items.map((industry, i) => (
          <span
            key={i}
            className="text-primary-foreground font-semibold text-base sm:text-lg flex-shrink-0 flex items-center"
          >
            <span className="mx-6 sm:mx-10">{industry}</span>
            <span className="text-primary-foreground/40">&#10022;</span>
          </span>
        ))}
      </div>
    </section>
  );
};
